import script from "./ChatDetailBody.vue?vue&type=script&setup=true&lang=js"
export * from "./ChatDetailBody.vue?vue&type=script&setup=true&lang=js"

import "./ChatDetailBody.vue?vue&type=style&index=0&id=26f24976&lang=scss"

const __exports__ = script;

export default __exports__